import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { getActiveSniSession } from '@/utils/sni-session'

Vue.use(VueRouter)

const routes = [
  {
    path: '/sleep-manual/:section(.*)?',
    name: 'SleepManual',
    component: () => import('../views/SleepManual.vue'),
    meta: {
      title: '睡眠管家 · 使用说明'
    }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('../views/Error.vue'),
    meta: {
      title: '提示'
    }
  },
  {
    path: '/queryList',
    name: 'QueryList',
    component: () => import('../views/QueryList.vue'),
    meta: {
      title: '问卷列表',
      requiresAuth: true
    }
  },
  {
    path: '/query',
    name: 'Query',
    component: () => import('../views/Query.vue'),
    meta: {
      title: store.state.configurationModel?.model.name ?? '问卷',
      requiresAuth: true
    }
  },
  {
    path: '/resultList',
    name: 'ResultList',
    component: () => import('../views/ResultList.vue'),
    meta: {
      title: '测评结果',
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/nppv-video-guide',
    name: 'NppvVideoGuideHome',
    component: () => import('../views/NppvVideoGuide.vue'),
    meta: {
      title: 'NPPV相关视频指导'
    }
  },
  {
    path: '/nppv-video-guide/list',
    name: 'NppvVideoGuideList',
    component: () => import('../views/NppvVideoGuide.vue'),
    meta: {
      title: '呼吸机使用指导'
    }
  },
  {
    path: '/nppv-video-guide/play',
    name: 'NppvVideoGuidePlay',
    component: () => import('../views/NppvVideoGuide.vue'),
    meta: {
      title: 'NPPV相关视频指导'
    }
  },
  {
    path: '/aroma-report/list',
    name: 'AromaReportList',
    component: () => import('../views/AromaReportList.vue'),
    meta: {
      title: '睡眠管家报告',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/aroma-report/shop',
    name: 'AromaShop',
    component: () => import('../views/AromaShop.vue'),
    meta: {
      title: '商城',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/aroma-report/product',
    name: 'AromaProductDetail',
    component: () => import('../views/AromaProductDetail.vue'),
    meta: {
      title: '纯植物精油复配芳香液',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/aroma-report/checkout',
    name: 'AromaCheckout',
    component: () => import('../views/AromaCheckout.vue'),
    meta: {
      title: '确认订单',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/aroma-report/pay-result',
    name: 'AromaPayResult',
    component: () => import('../views/AromaPayResult.vue'),
    meta: {
      title: '支付结果',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/aroma-report/mine',
    name: 'AromaMine',
    component: () => import('../views/AromaMine.vue'),
    meta: {
      title: '我的',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/aroma-report/login',
    name: 'AromaReportLogin',
    component: () => import('../views/AromaReportLogin.vue'),
    meta: {
      title: '睡眠管家登录'
    }
  },
  {
    path: '/aroma-report/bind-guide',
    name: 'AromaBindGuide',
    component: () => import('../views/AromaBindGuide.vue'),
    meta: {
      title: '绑定设备'
    }
  },
  {
    path: '/aroma-report/scanner',
    name: 'AromaDeviceScanner',
    component: () => import('../views/AromaDeviceScanner.vue'),
    meta: {
      title: '绑定设备'
    }
  },
  {
    path: '/aroma-report/profile',
    name: 'AromaReportProfile',
    component: () => import('../views/AromaReportProfile.vue'),
    meta: {
      title: '完善基础信息',
      aromaRequiresAuth: true
    }
  },
  {
    path: '/aroma-report/detail',
    name: 'AromaReportDetail',
    component: () => import('../views/AromaReportDetail.vue'),
    meta: {
      title: '报告详情',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/aroma-report/share',
    name: 'AromaReportShare',
    component: () => import('../views/AromaReportShare.vue'),
    meta: {
      title: '分享报告',
      aromaRequiresAuth: true,
      aromaRequiresProfile: true
    }
  },
  {
    path: '/',  // 程序启动默认路由
    redirect: '/home',  // 重定向到首页
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '主页',
      requiresAuth: true
    }
  },
  {
    path: '/record',
    name: 'Record',
    component: () => import('../views/Record.vue'),
    meta: {
      title: '测评记录',
      requiresAuth: true
    }
  },
  {
    path: '/record-detail',
    name: 'RecordDetail',
    component: () => import('../views/RecordDetail.vue'),
    meta: {
      title: '记录详情',
      requiresAuth: true
    }
  },
  {
    path: '/description',
    name: 'Description',
    component: () => import('../views/Description.vue'),
    meta: {
      title: '简介',
      requiresAuth: true
    }
  },
  {
    path: '/complete',
    name: 'Complete',
    component: () => import('../views/Complete.vue'),
    meta: {
      title: '完善信息',
      requiresAuth: true
    }
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/Main.vue'),
    meta: {
      title: '',
      requiresAuth: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    // The manual retains each topic's scroll offset and expanded sections locally.
    if (to.name === 'SleepManual') return false
    return savedPosition || { x: 0, y: 0 }
  }
})

// 解决路由跳转同一地址的报错
const originalPush = router.push
const originalReplace = router.replace
// push
router.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
router.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

// 动态设置标签页标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.matched.some(record => record.meta.aromaRequiresAuth)) {
    const sn = to.query.sn || ''
    const session = getActiveSniSession(sn)
    if (!session?.token) {
      if (to.name === 'AromaReportList' && sn) {
        next({ name: 'AromaBindGuide', query: { sn } })
        return
      }
      next({
        name: 'AromaReportLogin',
        query: {
          ...(sn ? { sn } : {}),
          redirect: to.fullPath
        }
      })
      return
    }
    if (to.matched.some(record => record.meta.aromaRequiresProfile) && session.profileCompleted === false) {
      next({
        name: 'AromaReportProfile',
        query: {
          ...(sn ? { sn } : {}),
          redirect: to.fullPath
        }
      })
      return
    }
    next()
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    const isAuthenticated = store.getters['user/isAuthenticated']
    if (!isAuthenticated) {
      // 用户未登录，存储目标路由
      store.commit('setRedirectTo', to.fullPath);
      next({
        path: '/login',
        query: {
          hospitalId: to.query.hospitalId
        }
      }); // 如果未登录，重定向到登录页面
    } else {
      next(); // 继续导航
    }
  } else {
    next();
  }
  
})

export default router
